import UrlBaseProvider from "./urlBaseProvider";

export default class MicroserviceHomeProvider extends UrlBaseProvider {
	constructor($http, sourceUrl, storage, eventBus) {
		super(`home_${sourceUrl}`, sourceUrl, $http, storage, eventBus);
	}
}
